import * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { NativeSelect } from './NativeSelect';

const TIMES_HALF = Array.from({ length: 48 }, (_, i) => {
  const h = Math.floor(i / 2).toString().padStart(2, '0');
  const m = i % 2 === 0 ? '00' : '30';
  return `${h}:${m}`;
});

export interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

/** Compact time-of-day picker with 30-minute resolution (00:00 – 23:30). */
export function TimePicker({ value, onChange, disabled, className, id }: TimePickerProps) {
  return (
    <NativeSelect
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={cn('h-9 w-[90px]', className)}
    >
      {TIMES_HALF.map((t) => (
        <option key={t} value={t}>
          {t}
        </option>
      ))}
    </NativeSelect>
  );
}
